import { render, staticRenderFns } from "./score-rate-secret-items.vue?vue&type=template&id=95ad67fe&scoped=true"
import script from "./score-rate-secret-items.vue?vue&type=script&lang=js"
export * from "./score-rate-secret-items.vue?vue&type=script&lang=js"
import style0 from "./score-rate-secret-items.vue?vue&type=style&index=0&id=95ad67fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ad67fe",
  null
  
)

export default component.exports